import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Payment } from '@payment/const';
import { StateUtils } from '@spartacus/core';
import { PaymentState, StateWithPayment } from '../payment-state';
import { getPaymentState } from './state.selectors';

const getPaymentListState: MemoizedSelector<StateWithPayment, StateUtils.LoaderState<Payment[]>> = createSelector(
  getPaymentState,
  (state: PaymentState) => state.paymentList,
);

export const getPaymentsLoading: MemoizedSelector<StateWithPayment, boolean> = createSelector(
  getPaymentListState,
  (state: StateUtils.LoaderState<Payment[]>) => StateUtils.loaderLoadingSelector(state),
);

export const getPaymentsError: MemoizedSelector<StateWithPayment, boolean> = createSelector(
  getPaymentListState,
  (state: StateUtils.LoaderState<Payment[]>) => StateUtils.loaderErrorSelector(state),
);

export const getPaymentsValue: MemoizedSelector<StateWithPayment, Payment[]> = createSelector(
  getPaymentListState,
  (state: StateUtils.LoaderState<Payment[]>) => StateUtils.loaderValueSelector(state) || [],
);
